import {Injectable} from '@angular/core';
import {SessionService} from '../session.service';
import {HttpClient} from '@angular/common/http';
import {BaseHttpService} from '../base.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class JoinedInterviewsService extends BaseHttpService {

  private static questionnairesPath = 'api/ecv/all_interviews/';

  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  getAllInterviews(refNumber: string): Observable<any> {
    return this.httpGet(JoinedInterviewsService.questionnairesPath + refNumber);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/joined-interviews.service.ts